// @ts-nocheck
const getFilenameFromDisposition = (headerValue) => {
  if (!headerValue) return 'archivo.zip';

  let match = headerValue.match(/filename="?([^";]+)"?/);
  if (match) return match[1];

  match = headerValue.match(/filename\*\s*=\s*UTF-8''([^;]+)/);
  if (match) return decodeURIComponent(match[1]);

  return 'archivo.zip';
};
const isIOS = () => {
  if (typeof navigator === 'undefined') {
    return false;
  }
  const userAgent = navigator.userAgent || '';
  const isAppleDevice = /Macintosh|MacIntel|iPad|iPhone|iPod/.test(userAgent);
  const isNotMSStream = !window.MSStream;
   return isAppleDevice && isNotMSStream;
};
export  {getFilenameFromDisposition, isIOS};
